import {
    HistoryData,
    HistoryFilterType,
    HistoryResources,
    HistorySuccessResponse,
    NormalizedHistory
} from '../../../responses/history'
import { ID, PayloadType } from '../../../types/UtilityTypes'
import { Comment, CommentData } from '../../../responses/comments'
import * as R from 'fp-ts/es6/Record'
import { createAction, createAsyncAction } from 'typesafe-actions'
import { pipe } from 'fp-ts/es6/function'

export type HistoryFilters = {
    filterType: HistoryFilterType[],
} & ({
    type: 'project',
    projectId: ID,
} | {
    type: 'work-object',
    objectId: ID,
} | {
    type: 'task',
    taskId: ID,
})

export const concatResources = (old: HistoryResources, changes: Partial<HistoryResources>): HistoryResources => pipe(old,
    R.mapWithIndex((key, value) => ({
        ...value,
        ...changes[key],
    }))
)


export const historyActions = {
    quote: createAction('@HISTORY/QUOTE')<Comment | null>(),
    startEdit: createAction('@HISTORY/START_EDIT')<Comment>(),
    startDelete: createAction('@HISTORY/START_DELETE')<Comment>(),
    cancelEdit: createAction('@HISTORY/CANCEL_EDIT')(),
    append: createAction('@HISTORY/APPEND')<NormalizedHistory>(),
    socketUpdate: createAction('@HISTORY/SOCKET_UPDATE')<NormalizedHistory>(),
    toggle: createAction('@HISTORY/TOGGLE')(),
    read: createAsyncAction(
        '@HISTORY/READ_REQUEST',
        '@HISTORY/READ_SUCCESS',
        '@HISTORY/READ_FAILURE',
    )<ID, ID, void>(),
    readAll: createAsyncAction(
        '@HISTORY/READ_ALL_REQUEST',
        '@HISTORY/READ_ALL_SUCCESS',
        '@HISTORY/READ_ALL_FAILURE',
    )<undefined, HistoryFilters, void>(),
    fetch: createAsyncAction(
        '@HISTORY/FETCH_REQUEST',
        '@HISTORY/FETCH_SUCCESS',
        '@HISTORY/FETCH_FAILURE',
    )<HistoryFilters, HistorySuccessResponse, void>(),
    comment: createAsyncAction(
        '@HISTORY/COMMENT_REQUEST',
        '@HISTORY/COMMENT_SUCCESS',
        '@HISTORY/COMMENT_FAILURE',
    )<{ filters: HistoryFilters, data: CommentData }, [Comment, PayloadType], void>(),
    deleteComment: createAction('@HISTORY/DELETE_COMMENT')<{ data: HistoryData[], correction: number }>(),
    delete: createAsyncAction(
        '@HISTORY/DELETE_REQUEST',
        '@HISTORY/DELETE_SUCCESS',
        '@HISTORY/DELETE_FAILURE',
    )<undefined, ID, void>(),
}